
// import Subscription from './Subscription.vue'
import FooterBottom from './FooterBottom.vue'
import FooterCopyright from './FooterCopyright.vue'
import { mapGetters } from 'vuex'
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  components: { /* Subscription, */ FooterBottom, FooterCopyright },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
    }),
  },
}
